import { render, staticRenderFns } from "./LinkedIn.vue?vue&type=template&id=6c3c9f56&scoped=true&"
import script from "./LinkedIn.vue?vue&type=script&lang=js&"
export * from "./LinkedIn.vue?vue&type=script&lang=js&"
import style0 from "./LinkedIn.vue?vue&type=style&index=0&id=6c3c9f56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3c9f56",
  null
  
)

export default component.exports